let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9mBQe")).then(() => parcelRequire('1ljzV'));